export enum NavigationButtonType {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum NavButtonEvent {
  NAV_BUTTON_DISPLAY_CHANGE = 'navButtonDisplayChange',
}

export enum NavButtonType {
  TOP = 'top',
  BOTTOM = 'bottom',
}
